import { Button } from '@cottage/design-system/internal-tooling/ui'

type DiscardConfirmProps = {
  title: string
  message: string
  confirmLabel?: string
  confirmVariant?: 'primary' | 'danger'
  onCancel: () => void
  onConfirm: () => void
}

export default function DiscardConfirm({
  title,
  message,
  confirmLabel = 'Discard changes',
  confirmVariant = 'primary',
  onCancel,
  onConfirm,
}: DiscardConfirmProps) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="discard-confirm-title"
        className="relative w-full max-w-md rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="discard-confirm-title" className="text-sm font-semibold text-gray-900">
          {title}
        </h3>
        <p className="mt-3 text-sm text-gray-600">{message}</p>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant={confirmVariant} size="md" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
